import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('campaigns');

const campaignsRoutes = [
  {
    path: '/campaigns',
    component: {
      render: (c) => c('router-view'),
    },
    meta: {
      feature: 'campaigns',
    },
    children: [
      {
        path: '/',
        meta: { showNav: true, feature: 'campaigns' },
        component: loadView('Campaigns'),
        children: [
          {
            path: '',
            name: 'campaigns',
            meta: { feature: 'campaigns' },
            component: loadView('CampaignsMain'),
          },
          {
            path: 'templates',
            name: 'campaigns-templates',
            meta: { feature: 'campaigns' },
            component: () =>
              import(
                /* webpackChunkName: "app-campaign-templates" */ '@/views/campaignTemplates/CampaignTemplates.vue'
              ),
          },
        ],
      },

      {
        path: 'create',
        name: 'campaign-create',
        props: true,
        meta: { feature: 'campaigns' },
        component: loadView('CampaignCreate'),
      },
      {
        path: ':campaignId/test/:triggerId?',
        name: 'campaign-test',
        props: true,
        meta: { feature: 'campaigns' },
        component: loadView('CampaignTest'),
      },
      {
        path: ':campaignId/:type?',
        name: 'campaign-edit',
        props: true,
        meta: { feature: 'campaigns' },
        component: loadView('CampaignForm'),
      },
      {
        path: ':campaignId/triggers/:id',
        props: true,
        name: 'campaign-trigger-edit',
        meta: { feature: 'campaigns' },
        component: () =>
          import(
            /* webpackChunkName: "app-campaigns-form" */ '@/views/automations/form/AutomationForm'
          ),
      },
    ],
  },
];

export default campaignsRoutes;
